<template>
	<div>
		<v-app-bar app fixed dark color="rojo" class="">
			<v-img
				alt="Instituto de los Mexicanos en el Exterior"
				class="shrink"
				contain
				width="100"
				:src="`${logoIme}`"
				:lazy-src="`${logoIme}`" />

			<h1 class="ml-6 dorado-text text-h6 text--uppercase font-weight-bold">
				Concursos
			</h1>

			<v-spacer></v-spacer>
			<v-btn dark rounded color="dorado" href="/vinculacion/concursos/altares/">
				<v-icon left>mdi-home</v-icon>
				Reto de altares
			</v-btn>
		</v-app-bar>
	</div>
</template>

<script>
	import logo from "@/assets/images/logos/ime-mx.png";

	export default {
		name: "HeaderTemplate",

		components: {},

		data: () => ({
			logoIme: logo,
			meta: {
				app_name: process.env.VUE_APP_NAME,
				base_url: process.env.VUE_APP_BASE_URL,
				endpoint: process.env.VUE_APP_ENDPOINT,
				storage_files: process.env.VUE_APP_STORAGE_FILES,
			},
		}),

		methods: {},
	};
</script>
